import getMixedFileType from 'utils/getMixedFileType'

export default function onFilterFiles({ props, state }) {
  const files = state.get('media.files')
  const fileType = state.get(props.path)
  let repaint = false

  Object.keys(files).forEach(id => {
    const file = state.get(`media.files.${id}`)
    state.set(`media.files.${file.id}.selected`, false)
    if (getMixedFileType(file.extension) === fileType.type.toLowerCase()) {
      state.set(`media.files.${file.id}.hidden`, !fileType.selected)
      repaint = true
    }
  })

  if (repaint) state.set(`media.filter.repaint`, true)
}



// WEBPACK FOOTER //
// ./src/modules/Media/actions/onFilterFiles.js